import { Fragment } from "react";
import usePage from "../../hooks/usePage";
import Footer from "../../modules/public/footer/footer";
import Menu from "../../modules/public/menu/menu";
import DigikalaBanner from "./components/DigikalaBanner";
import DigikalaBenefits from "./components/DigikalaBenefits";
import DigikalaCooperation from "./components/DigikalaCooperation";
import DigikalaFAQ from "./components/DigikalaFAQ";
import DigikalaHero from "./components/DigikalaHero";
import DigikalaPrices from "./components/DigikalaPrices";

const Digikala = () => {
  const { pageSliders, pageImage, pageText, pageBody } = usePage();

  return (
    <Fragment>
      <Menu />

      {pageSliders}

      <main className="flex-grow-1">
        {pageSliders}

        <div className="container">
          <DigikalaHero hero={pageBody.hero} />
          <DigikalaBenefits benefits={pageBody.benefits} />
          <DigikalaCooperation cooperation={pageBody.cooperation} />
          <DigikalaPrices prices={pageBody.prices} />

          {pageText}

          <DigikalaBanner banner={pageBody.banner} />
          <DigikalaFAQ faq={pageBody.faq} />

          {pageImage}
        </div>
      </main>

      <Footer />
    </Fragment>
  );
};

export default Digikala;
